import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { billingTransactionRefetchQueries } from '~/modules/common/components/RefetchQueries';

const DELETE_BILL = gql`
  mutation deleteBill($id: String!) {
    deleteBill2(id: $id)
  }
`;

export const useDeleteBill = createAndView => {
  const [deleteBill] = useMutation(DELETE_BILL);

  return {
    deleteBill: async billId => {
      await deleteBill({
        variables: {
          id: billId
        },
        skip: !billId,
        refetchQueries: createAndView
          ? ['getPageOfAvailableToBill']
          : [
              ...billingTransactionRefetchQueries,
              'getBillingTransactionSummary'
            ]
      });
    }
  };
};

export default useDeleteBill;
